import React from 'react';

function TaskBoard({ color = 'black', bgColor = 'white' }) {
  return (
    <>
      <svg width="34" height="34" viewBox="0 0 24 25" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
        <rect x="21" y="21.5" width="18" height="18" rx="4" transform="rotate(180 21 21.5)" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M13.125 6.5H10.875M13.125 9.5H10.875M13.125 12.5H10.875" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8.25 6.5H6M8.25 9.5H6M8.25 12.5H6M8.25 15.5H6" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M18 6.5H15.75M18 9.5H15.75M18 12.5H15.75M18 15.5H15.75M18 18.5H15.75" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      </svg>

    </>
  );
}

export default TaskBoard;
